import React, { ReactNode } from 'react';
import { globalStyles } from 'snacks-design-system';
import styles from './Mapcard.module.scss';
interface MapCardProps {
  children?: ReactNode;
  backgroundColor?: string;
  className?: string;
  onClick?: () => void;
}
export const MapCard = ({
  children,
  className,
  backgroundColor = globalStyles.xdsColorContentLight,
}: MapCardProps) => {
  return (
    (children && (
      <div style={{ backgroundColor }} className={`${styles.MapCardContainer} ${className}`}>
        {children}
      </div>
    )) || <></>
  );
};

export default MapCard;
